var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.179 7.04011L16.642 6.57611C17.0106 6.20733 17.5107 6.00009 18.0321 6C18.5536 5.99991 19.0537 6.20696 19.4225 6.57561C19.7913 6.94426 19.9985 7.44431 19.9986 7.96576C19.9987 8.4872 19.7916 8.98733 19.423 9.35611L18.96 9.82011M16.179 7.04011C16.179 7.04011 16.237 8.02411 17.106 8.89311C17.975 9.76211 18.96 9.82011 18.96 9.82011M16.179 7.04011L11.919 11.3001C11.629 11.5881 11.485 11.7331 11.361 11.8921C11.215 12.0801 11.09 12.2821 10.987 12.4981C10.9 12.6801 10.836 12.8731 10.707 13.2601L10.294 14.5001L10.16 14.9011M18.96 9.82011L14.7 14.0801C14.41 14.3701 14.266 14.5141 14.107 14.6381C13.919 14.7841 13.717 14.9091 13.501 15.0121C13.319 15.0991 13.126 15.1631 12.739 15.2921L11.499 15.7051L11.098 15.8391M10.16 14.9011L10.027 15.3031C9.99602 15.3964 9.9916 15.4965 10.0143 15.5922C10.0369 15.6879 10.0857 15.7754 10.1552 15.8449C10.2248 15.9144 10.3122 15.9632 10.4079 15.9859C10.5036 16.0085 10.6037 16.0041 10.697 15.9731L11.098 15.8391M10.16 14.9011L11.098 15.8391",
    stroke: "#FF3093",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H8.5M6 8H12.5M6 16H7.5M17.828 2.172C16.657 1 14.771 1 11 1H9C5.229 1 3.343 1 2.172 2.172C1 3.343 1 5.229 1 9V13C1 16.771 1 18.657 2.172 19.828C3.343 21 5.229 21 9 21H11C14.771 21 16.657 21 17.828 19.828C18.772 18.885 18.955 17.48 18.991 15",
    stroke: "#FF3093",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinear);
export default __webpack_public_path__ + "static/media/linear.0b97dea1fe1bdddb23ac2ab5241671b9.svg";
export { ForwardRef as ReactComponent };